import { render, staticRenderFns } from "./create.vue?vue&type=template&id=535edc6d&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=535edc6d&prod&lang=less"
import style1 from "./create.vue?vue&type=style&index=1&id=535edc6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535edc6d",
  null
  
)

export default component.exports